import { Component, OnInit } from '@angular/core';
import { VerifyAccountService } from './verify-account.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';

@Component({
    selector: 'app-verify-account',
    templateUrl: './verify-account.component.html',
    styleUrls: ['./verify-account.component.scss']
})
export class VerifyAccountComponent implements OnInit {

    detailsObj: any = {};
    linkStatus: String;
    passwordForm: FormGroup;

    constructor(
        private _verifyAccountService: VerifyAccountService,
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _formBuilder: FormBuilder
    ) { }

    ngOnInit() {
        console.log(this._activatedRoute.snapshot.queryParams.code);
        this._verifyAccountService.isCodeValid(this._activatedRoute.snapshot.queryParams.code)
            .subscribe(
                (result: any) => {
                    this.linkStatus = 'ACTIVE';
                    this.passwordForm = this._formBuilder.group({
                        password: ['', [Validators.required, Validators.minLength(8)]],
                        confirmPassword: ['', [Validators.required]],
                    });
                },
                (err) => {
                    console.log('err ', err);
                    err.status === 500 ? this.linkStatus = '500' : this.linkStatus = 'EXPIRED';
                });
    }

    verifyAccount() {
        if (this.passwordForm.valid && !this.isNotMatching()) {
            this.detailsObj.verificationCode = this._activatedRoute.snapshot.queryParams.code;
            this.detailsObj.password = this.passwordForm.value.password;
            this._verifyAccountService.verifyAccountAndSetPassword(this.detailsObj)
                .subscribe(
                    (result: any) => {
                        this._router.navigateByUrl('');
                    },
                    (err) => {
                        console.log(err);
                    }
                );
        } else {
            this.validateAllFormFields(this.passwordForm);
        }
    }

    isFieldValid(field: string) {
        return !this.passwordForm.get(field).valid && this.passwordForm.get(field).touched;
    }

    isNotMatching() {
        // tslint:disable-next-line:max-line-length
        return (this.passwordForm.get('password').value !== this.passwordForm.get('confirmPassword').value) && this.passwordForm.get('confirmPassword').touched && this.passwordForm.get('password').valid;
    }

    displayFieldCss(field: string) {
        return {
            'has-error': this.isFieldValid(field)
        };
    }

    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            console.log(field);
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({ onlySelf: true });
            } else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/verify-account/verify-account.component.ts